import { Card, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { ECommerce, ProductPage } from "../../../../Constants/Constants";
import ImageSlider from "./ImageSlider";
import { useAppDispatch } from "../../../../ReduxToolkit/Hooks";
import { fetchProductApiData } from "../../../../ReduxToolkit/Reducers/ECommerce/ProductSlice";
import { useEffect } from "react";
import ProductDetails from "./ProductDetails";
import BrandDetail from "./BrandDetail";
import ClothsDetails from "./ClothsDetails";

const ProductPageContainer = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchProductApiData());
  }, [dispatch]);
  return (
    <>
      <Breadcrumbs mainTitle={ProductPage} parent={ECommerce} />
      <Container fluid>
        <div>
          <Row className="product-page-main p-0">
            <ImageSlider />
            <ProductDetails />
            <BrandDetail />
            <Card>
              <Row className="product-page-main">
                <ClothsDetails />
              </Row>
            </Card>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default ProductPageContainer;
